<template>
<div class="logFilesBox">
<div class="header">
    <div
    v-for="(item,index) in stateList"
    :key="index"
    :class="{heightlight : lableindex==index}"
    @click="search(item,index)"
    >
        <span>{{item.name}}</span>
        <div v-if="lableindex==index" class="xian"></div>
    </div>
</div>
<el-table :span-method="mergeMethod" :data="list" border style="width:100%;" height="480px">
    <el-table-column prop="dates" label="日期" align="center" width="100"></el-table-column>
    <el-table-column prop="begintime" label="开始时间" align="center" width="80">
        <template slot-scope="scope">
            <span>{{scope.row.begintime.split(' ')[1]}}</span>
        </template>
    </el-table-column>
    <el-table-column prop="endtime" label="结束时间" align="center" width="80">
        <template slot-scope="scope">
            <span>{{scope.row.endtime.split(' ')[1]}}</span>
        </template>
    </el-table-column>
    <el-table-column prop="name" label="内容" align="left" show-overflow-tooltip min-width="200"></el-table-column>
    <el-table-column prop="address" label="地点" align="left" show-overflow-tooltip min-width="100"></el-table-column>
    <el-table-column prop="remark" label="备注" align="left" show-overflow-tooltip min-width="100"></el-table-column>
    <el-table-column label="日志" align="center" show-overflow-tooltip width="90">
        <template slot-scope="scope">
            <span style="color: green;" v-if="scope.row.status > 0">已完成</span>
            <span style="color: red;" v-else>未完成</span>
        </template>
    </el-table-column>
    <el-table-column width="120px" label="操作" align="center">
        <template slot-scope="scope">
            <el-button type="primary" @click.prevent="toEditLogFileUrl(scope.row)" plain size="mini">
                <span v-if="scope.row.status > 0">编辑日志</span>
                <span v-else>填写日志</span>
            </el-button>
        </template>
    </el-table-column>
</el-table>
  <div class="pagination">
    <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="listQuery.limit"
        layout="total,sizes, prev, pager, next"
        :total="total"
        v-if="total > 0"
    ></el-pagination>
  </div>
</div>
</template>

<script>
import {
    getClassMasterJournalApi
} from '@/api/personcenter/index';
export default {
    props:['trainId','trainName'],
    data(){
        return {
            stateList:[
                { name: '全部', id: -1 },
                { name: '未完成', id: 0 },
                { name: '已完成', id: 1 },
            ],
            listQuery: {
                page: 1,
                limit: 10,
                userId: this.$store.state.User.ids,
                trainId: this.trainId,
            },
            list:[],
            total: 0,
            lableindex: 0,
        }
    },
    created(){
        this.getList();
    },
    methods:{
        search(row,index){
            this.listQuery.status = row.id != -1 ? row.id : null;
            this.lableindex = index;
            this.listQuery.page = 1;
            this.getList();
        },
        getList(){
            getClassMasterJournalApi(this.listQuery).then(res=>{
                this.list = res.data;
                if(this.list.length > 1){
                    this.list.sort((a, b) => new Date(a.begintime) - new Date(b.begintime));
                }
              this.total = res.count;
            })
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        //去填写日志
        toEditLogFileUrl(row){
            let time = row.begintime.split(' ')[0];
            this.$router.push({
                path:'/classReport',
                query:{
                    id: row.id,
                    trainId: this.trainId,
                    trainName: this.trainName,
                    time: time
                }
            })
        },
        //合并方法
        mergeMethod({ row, column, rowIndex, columnIndex }){
            //对下标0的数据列进行判断
            if (columnIndex === 0 || columnIndex === 6 || columnIndex === 7){
                let sum = 0;
                let state = false;
                let firstIndex = this.list.findIndex(item=>item.dates === row.dates);
                //判断当前下标是不是这个date首个的那行数据
                if(rowIndex === firstIndex){
                    let arr = this.list.filter(item=>item.dates === row.dates);
                    if(arr && arr.length > 0){ sum = arr.length };
                    state = true;
                }else{
                    state = false;
                }
                
                if (state){
                    return {
                        rowspan: sum,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.logFilesBox{
    .searchModel{
        padding-bottom: 10px;
    }

    .header {
        height: 35px;
        border-bottom: solid 1px #ccc;
        padding-bottom: 2px;
        display: flex;
        &> div {
            width: 100px;
            text-align: center;
            line-height: 35px;
            font-size: 16px;
            cursor: pointer;
            &:hover{
                color: #409eff;
            }
            .xian {
                width: 90px;
                border: solid 1px #409eff;
                margin-left: 8px;
            }
        }
        .heightlight {
            color: #409eff !important;
        }
    }
}
.pagination{
    padding-top: 10px;
}
</style>
<style scoped>
/deep/.searchModel .el-input .el-input__inner{
    border-radius: 4px !important;
}
</style>